import { useEffect, useLayoutEffect, useRef } from 'react';

type Props = {
  keyDown?: (event: KeyboardEvent) => void;
  keyUp?: (event: KeyboardEvent) => void;
};

export const useKeyboard = ({ keyDown, keyUp }: Props) => {
  const keyDownRef = useRef(keyDown);
  const keyUpRef = useRef(keyUp);
  useLayoutEffect(() => {
    keyDownRef.current = keyDown;
    keyUpRef.current = keyUp;
  });

  useEffect(() => {
    if (!keyDown) return;

    window.addEventListener('keydown', keyDown);

    return () => window.removeEventListener('keydown', keyDown);
  }, [keyDown]);

  useEffect(() => {
    if (!keyUp) return;

    window.addEventListener('keyup', keyUp);

    return () => window.removeEventListener('keyup', keyUp);
  }, [keyUp]);
};
